"use client";

import React, { PropsWithChildren, useEffect, useState } from "react";
import Sidebar from "./SideBar";
import ProfileBar from "./ProfileBar";
import MenuBarMobile from "./MenuBarMobile";
import AdminBar from "./AdminBar";
import { usePathname } from "next/navigation";
import Loader from "../Loader";
import { useAppSelector } from "@/redux/store";
import PartnerPortalSidebar from "./PartnerPortalSidebar";

export default function NavBarLayout() {
  // Mobile sidebar visibility state
  const [showSidebar, setShowSidebar] = useState(false);
  const pathname = usePathname();
  const Loading = useAppSelector((state) => state.appReducer.Loading);
  const authValue = useAppSelector((state) => state.appReducer.auth);
  const userData = useAppSelector((state) => state.appReducer.userData);

  const showSideBar = () => {
    if (pathname.startsWith("/admin")) {
      return <AdminBar show={showSidebar} setter={setShowSidebar} />;
    } else if (pathname.startsWith("/profile")) {
      return <ProfileBar show={showSidebar} setter={setShowSidebar} />;
    } else if (pathname.startsWith("/partner-portal")) {
      return (
        <PartnerPortalSidebar show={showSidebar} setter={setShowSidebar} />
      );
    } else {
      return <Sidebar show={showSidebar} setter={setShowSidebar} />;
    }
  };

  const ModalOverlay = ({ setShowSidebar }: any) => {
    useEffect(() => {
      // Disable scrolling on mount
      document.body.style.overflow = 'hidden';

      return () => {
        // Re-enable scrolling on unmount
        document.body.style.overflow = 'auto';
      };
    }, []);
    return (
      <div
        className={`flex md:hidden fixed top-0 right-0 bottom-0 left-0 bg-black/50 z-30`}
        onClick={() => {
          setShowSidebar(false);
        }}
        style={{ cursor: 'pointer' }}
      />

    )
  };

  return (
    <>
      {Loading.isLoading && <Loader message={Loading.message} />}
      {!pathname.includes("/form/") ? (
        <div>
          <MenuBarMobile setter={setShowSidebar} />
          {authValue.isAuth && userData?.tags && (
            <Layout show={showSidebar}>{showSideBar()}</Layout>
          )}
          {authValue.isAuth && userData?.tags && showSidebar && (
            <ModalOverlay setShowSidebar={setShowSidebar} />
          )}
        </div>
      ) : null}
    </>
  );
}

type LayoutProps = {
  show: boolean;
};

function Layout({ show, children }: PropsWithChildren<LayoutProps>) {
  const selectedTag = useAppSelector((state) => state.dashboardReducer.selectedCategory);
  const className =
    "w-[15.625rem] transition-[margin-left] ease-in-out duration-500 fixed md:static top-0 bottom-0 left-0 z-40";
  const appendClass = show ? " ml-0" : " ml-[-250px] md:ml-0";
  const [backgroundGradiant, setBackgroundGradient] = useState<string>(
    "all-gradient-background"
  );

  useEffect(() => {
    setGradient(selectedTag);
  }, [selectedTag]);

  const setGradient = (slug: string) => {
    const gradiantBackground = `${slug}-gradient-background`;
    setBackgroundGradient(gradiantBackground);
  };

  return (
    <>
      <div
        id="default-sidebar"
        className={`${className}${appendClass} ${backgroundGradiant} md:h-screen min-h-screen default-sideBar`}
        aria-label="Sidebar"
      >
        <div className="min-h-screen bg-white bg-opacity-40">{children}</div>
      </div>
    </>
  );
}
